// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../npm_env_portal_2/node_modules/css-loader/index.js!../../../../../npm_env_portal_2/node_modules/postcss-loader/index.js!./global.css");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../../../../../npm_env_portal_2/node_modules/style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../npm_env_portal_2/node_modules/css-loader/index.js!../../../../../npm_env_portal_2/node_modules/postcss-loader/index.js!./global.css", function() {
			var newContent = require("!!../../../../../npm_env_portal_2/node_modules/css-loader/index.js!../../../../../npm_env_portal_2/node_modules/postcss-loader/index.js!./global.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/global.css
 ** module id = 3139
 ** module chunks = 0
 **/